import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { LocationDetailsService } from '../../services/location-details.service';

@Component({
  selector: 'signgaze-listing-owner',
  templateUrl: './listing-owner.component.html',
  styleUrls: ['./listing-owner.component.scss'],
})
export class ListingOwnerComponent implements OnChanges {
  @Input()
  ownerId: string;

  userInfo$: Observable<any>;

  constructor(private locationDetailService: LocationDetailsService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ownerId']) {
      if (this.ownerId) {
        this.getUserInfo();
      }
    }
  }

  private getUserInfo(): void {
    this.userInfo$ = this.locationDetailService.getUserInfo(this.ownerId);
  }
}
